import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox as FluentCheckbox, makeStyles } from "@fluentui/react-components";
import { useEffect, useState } from "react";
const useCheckboxStyles = makeStyles({
    indicator: {
        margin: 0,
    },
});
/**
 * This is a primitive fluent checkbox that can both read and write checked state
 * @param props
 * @returns Checkbox component
 */
export const Checkbox = (props) => {
    Checkbox.displayName = "Checkbox";
    const [checked, setChecked] = useState(() => props.value ?? false);
    const classes = useCheckboxStyles();
    useEffect(() => {
        if (props.value != undefined) {
            setChecked(props.value); // Update local state when props.checked changes
        }
    }, [props.value]);
    const onChange = (ev, _) => {
        props.onChange(ev.target.checked);
        setChecked(ev.target.checked);
    };
    return _jsx(FluentCheckbox, { checked: checked, onChange: onChange, indicator: { className: classes.indicator } });
};
//# sourceMappingURL=checkbox.js.map